<template>

<div class="container">
    <div class="row justify-content-center  mt-4 ">
            <div class="col-10">
             
                <div class="table-responsive tisch">
                    <table class="table" v-if="schedule.length>0">
  <thead>
    <tr class="color-bg">
      <th scope="col">#</th>
      <th scope="col">ლექტორი</th>
      <th scope="col">მოდული</th>
      <th scope="col">თარიღი</th>
      <th scope="col">დღე</th>
      <th scope="col">დრო</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="data of schedule">
      <th scope="row">{{ data.groupN }}</th>
      <td>{{ data.fname }} {{data.lname  }}</td>
      <td>{{ data.module_name }}</td>
      <td>{{ data.start_date }} - {{ data.finish_date }}</td>
      <td>{{ data.day }}</td>
      <td>{{ data.lecture_start }} - {{ data.lecture_end }}</td>
    </tr>
    
  </tbody>
</table>


            </div>


    </div>
</div>

</div>

</template>
<script>
import HttpRequests from '../httpRequests/httpRequests';
const httpRequests=new HttpRequests()
export default{
  data(){
    return{
    schedule:[]
    }
  },
  mounted(){


    httpRequests.getSchedule().then(response=>{
      this.schedule=response.data
    })

  }
}

</script>